import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    // Paper itself does not scroll (overflow hidden keeps the rounded corners
    // clean); the inner `body` scrolls. Paper padding insets that scroll area —
    // and its scrollbar — away from the rounded border on the right and bottom.
    paper: {
        borderRadius: 4,
        overflowY: 'hidden',
        padding: '8px 8px 20px',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexShrink: 0,
        padding: '16px 24px 12px',
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1.2,
    },
    subtitle: {
        marginTop: 4,
        color: theme.palette.text.secondary,
    },
    closeButton: {
        marginTop: -8,
    },
    body: {
        flex: '1 1 auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        // Reserve the vertical scrollbar's gutter unconditionally, so the width
        // available to the cards grid is constant regardless of whether the
        // scrollbar actually renders, or renders as a classic (space-occupying)
        // vs overlay scrollbar — a classic scrollbar appearing (e.g. mouse
        // connected on macOS, which switches away from overlay scrollbars) was
        // otherwise enough to tip the 3-card row down to 2. dialogMaxWidth in
        // index.jsx budgets extra width (SCROLLBAR_ALLOWANCE) to compensate.
        scrollbarGutter: 'stable',
        padding: '0px 16px 4px 24px',
    },
}));
